import BaseClass from "../BaseClass";

export default class IntervalCheck extends BaseClass {

    constructor(element) {
        super(element);

        this.jqxhr = null;
        this.timeOutHandle = null;
        this.sleepTime = 1000;

        this.$startButton = null;
        this.startListener = null;

        this.init();
    }

    init() {

        let mySelf = this;

        this.unsetRequest();
        this.unsetTimeOut();

        const startButton = this.$element.data('check-starter');
        if (startButton != 'undefined') {
            let $startButton = $('#' + startButton);

            if ($startButton.length == 1) {
                this.$startButton = $startButton;
            }
        }

        this.startListener = function () {
            $(document).trigger('show:loading');
            mySelf.prepareCheck();
        };
        if (this.$startButton != null) {
            this.$startButton.on('click', this.startListener);
        }
    }

    prepareCheck() {

        const sleepTime = this.$element.data('sleep-time');
        if (sleepTime != undefined && sleepTime.isInteger()) {
            this.sleepTime = sleepTime;
        }

        const checkUrl = this.$element.data('check-url');
        if (checkUrl != undefined) {
            this.doCheck(checkUrl)
        }
    }

    doCheck(checkUrl) {
        this.jqxhr = $.post(checkUrl, "", null, 'json')
            .done($.proxy(this.onDone, this))
            .fail($.proxy(this.onFail, this));
    }

    onDone(data) {
        if (data.success) {
            this.unsetTimeOut();
            this.unsetRequest();
            this.handleAjaxResponse(data);
        } else {
            this.unsetRequest();
            this.timeOutHandle = setTimeout($.proxy(this.prepareCheck, this), this.sleepTime);
        }
    }

    onFail() {
        this.unsetRequest();
        this.unsetTimeOut();
    }

    unsetRequest() {
        if (this.jqXHR != null) {
            this.jqXHR.abort();
            this.jqXHR = null;
        }
    }

    unsetTimeOut() {
        if (this.timeOutHandle != null) {
            clearTimeout(this.timeOutHandle);
            this.timeOutHandle = null;
        }
    }

    destroyListener() {
        if (this.jqXHR != null) {
            this.jqXHR.abort();
            this.jqXHR = null;
        }
        if (this.timeOutHandle != null) {
            clearTimeout(this.timeOutHandle);
            this.timeOutHandle = null;
        }
        if (this.startListener != null) {
            this.$startButton.off('click', this.startListener);
        }
    }

}